module.exports = __webpack_public_path__ + "img/emoji_daku.6f6f3d18.png";